import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const setSession = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* token may be expired */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };
  const isAdmin = !!user?.is_default_admin;
  const hasRole = (roles) => isAdmin || (user && roles.includes(user.role));
  return <AuthCtx.Provider value={{ user, setSession, logout, isAdmin, hasRole }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const MANAGER_ROLES = ["PLATFORM_SUPER_ADMIN", "GRC_MANAGER", "RISK_MANAGER", "AUDITOR"];
export const APPROVER_ROLES = ["PLATFORM_SUPER_ADMIN", "GRC_MANAGER", "RISK_MANAGER"];
export const USER_READ_ROLES = ["PLATFORM_SUPER_ADMIN", "PORTAL_USER_MANAGER"];
export const EDITOR_ROLES = [...APPROVER_ROLES, "SECURITY_ARCHITECT", "SECURITY_ANALYST", "SOC_L1", "SOC_L2", "SOC_L3",
  "INCIDENT_RESPONDER", "DFIR_ANALYST", "ITSM_ENGINEER", "DEVSECOPS_ENGINEER", "SECURITY_ENGINEER"];
